import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { cancelChanges, changeJobseekerPrivacy, loadJobseekerPrivacy, updateJobseekerPrivacy } from 'src/app/root-store/jobseeker-store/jobseeker-settings/actions';
import { selectJobseekerPrivacyList, selectSelectedJobseekerPrivacy } from 'src/app/root-store/jobseeker-store/jobseeker-settings/selectors';
import { AppState } from 'src/app/root-store/state';
import { ButtonTypeEnum } from '@hrra/ui';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { BasicOptionItem, JobseekerPrivacyEnum } from '@hrra/common-models';

@Component({
    selector: 'app-jobseeker-settings-privacy',
    templateUrl: './redesign/jobseeker-settings-privacy.component.html',
    styleUrls: ['./redesign/jobseeker-settings-privacy.component.scss'],
    standalone: false
})
export class JobseekerSettingsPrivacyComponent implements OnInit {

  privacyList$: Observable<BasicOptionItem[]>;
  selectedPrivacy$: Observable<number>;

  public privacyEnum: any;
  public buttonType: any;
  public buttonAttributeType: any;
  public privacyMap: {[index: number]: {label: string, text: string}};

  constructor(private store: Store<AppState>) { 
    this.privacyEnum = JobseekerPrivacyEnum;
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;
  }

  ngOnInit(): void {

    setTimeout(() => {
      this.store.dispatch(loadJobseekerPrivacy());

    }, 0);

    this.privacyList$ = this.store.pipe(select(selectJobseekerPrivacyList));
    this.selectedPrivacy$ = this.store.pipe(select(selectSelectedJobseekerPrivacy));

    this.privacyMap = {
      [JobseekerPrivacyEnum.AvailableToAllCustomers]: {label: 'label.AvailableToAllCustomers', text: 'text.JobseekerAvailableToAllCustomersPrivacyDefinition'},
      [JobseekerPrivacyEnum.Public]: {label: 'label.Public', text: 'text.JobseekerPublicPrivacyDefinition'},
      [JobseekerPrivacyEnum.Hidden]: {label: 'label.HiddenFromEveryone', text: 'text.JobseekerHiddenPrivacyDefinition'}
    }
  }

  onChangeJobseekerPrivacy(privacyId: number){
    this.store.dispatch(changeJobseekerPrivacy({payload: {privacyId: privacyId}}));
  }

  onCancel(){
    this.store.dispatch(cancelChanges());
  }

  onSave(privacyId: number){
    this.store.dispatch(updateJobseekerPrivacy({payload: {privacyId: privacyId}}));
  }
}
